import { createSelector } from 'reselect';

export const getAccountMembers = state =>
  state?.profilesManager?.profilesInfo?.members || [];

export const getAdminProfileId = createSelector(
  getAccountMembers,
  members => {
    const adminUser = members.find(member => member.admin);
    return adminUser && adminUser.partnerUserId;
  },
);
